/**
 * Ambiente runtime dalla hostname del browser.
 * @returns {'prod' | 'test' | 'dev'}
 */
export function getEnvironment() {
  if (typeof window === 'undefined' || !window.location?.hostname) return 'prod';
  const h = window.location.hostname.toLowerCase();
  if (
    h === '64.226.103.60' ||
    h === '129.212.254.120' ||
    h === 'test.fitgymtrack.com' ||
    h === '64-226-103-60.sslip.io'
  ) {
    return 'test';
  }
  if (h === 'localhost' || h === '127.0.0.1' || h === '192.168.1.113') return 'dev';
  if (h === 'www.fitgymtrack.com' || h === 'fitgymtrack.com' || h === '138.68.80.170' || h === '104.248.103.182') {
    return 'prod';
  }
  return 'prod';
}
